import styled from "styled-components";

export const TDX_IFRAME_OVERRIDE_CSS = `
  .tdxFigureContainer iframe {
    position: inherit !important;
    visibility: visible !important;
    top: auto !important;
    left: auto !important;
  }
`;

// BV renders the TDX wrapper as a bare div (height:100%, class tdxFigureContainer)
// with no spacing of its own - any padding/margin here shifts the whole embed
// relative to BV (a 1rem padding read as a 16px x-offset on every TDX band)
export const TextbookTdx = styled.div`
  margin: 0;
  padding: 0;
  border: none;

  /* Theme CSS is rescoped under #viewer-express-container (cssProcessor), which
     lifts every theme rule to ID specificity. In BV the same theme applies
     unscoped, so the embed's own class rules beat its element rules; here they
     lose. Restore the two TDX values the theme is known to override - the
     theme's "body ul { list-style-type: disc }" drew bullets on the zoom
     toolbar (ul.fab), and its "table { border-collapse: collapse }" collapsed
     the data tables TDX renders with separate 1px borders (rows 1px shorter
     than BV). Scoped to TDX's own selectors, not blanket resets: TDX content
     lists and tables keep their own rules. A scoping-layer fix (:where()
     prefix) was tried and reverted: it also drops the theme below Express
     renderer styles everywhere else (e.g. the indented article paragraphs). */
  #viewer-express-container && ul.fab {
    list-style: none;
  }
  #viewer-express-container && .assessmentItem .tableContentItem {
    border-collapse: separate;
    border-spacing: 0;
  }
`;

export const TdxLoading = styled.div`
  padding: 2rem;
  text-align: center;
  color: var(--text-color-secondary, #666);
`;

export const TdxError = styled.div`
  padding: 1rem;
  background-color: var(--error-background, #fee);
  border: 1px solid var(--error-border, #fcc);
  border-radius: 4px;
  color: var(--error-text, #c00);

  p {
    margin: 0;
  }
`;
